import { useLocation } from "react-router";
import type { ProductType } from "../navigation/types";

export function useProductType(): ProductType | null {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);

  // Get the first segment, which should be the product type
  const firstSegment = pathSegments[0];

  if (!firstSegment) {
    return null;
  }

  // Handle OLB routes (e.g., /olb-personal-loan/...)
  if (firstSegment.startsWith("olb-")) {
    const productPart = firstSegment.replace("olb-", "");
    return productPart as ProductType;
  }

  // Handle standard routes (e.g., /personal-loan/...)
  return firstSegment as ProductType;
}
